module.exports = __webpack_public_path__ + "img/logo15.e149fca9.png";